import React from 'react';
import type { Milestone } from '../types/portal';
const styles: Record<Milestone, {
  pill: string;
  dot: string;
}> = {
  'Pre-Approved': {
    pill: 'bg-slate-100 text-slate-700 ring-slate-200',
    dot: 'bg-slate-400'
  },
  Application: {
    pill: 'bg-slate-100 text-slate-700 ring-slate-200',
    dot: 'bg-slate-500'
  },
  Appraisal: {
    pill: 'bg-amber-50 text-amber-800 ring-amber-200',
    dot: 'bg-amber-500'
  },
  Underwriting: {
    pill: 'bg-sky-50 text-sky-800 ring-sky-200',
    dot: 'bg-sky-500'
  },
  'Conditional Approval': {
    pill: 'bg-indigo-50 text-indigo-800 ring-indigo-200',
    dot: 'bg-indigo-500'
  },
  'Clear to Close': {
    pill: 'bg-accent-soft text-accent-dark ring-accent/30',
    dot: 'bg-accent'
  },
  Closed: {
    pill: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    dot: 'bg-emerald-500'
  }
};
export function MilestonePill({
  milestone
}: {
  milestone: Milestone;
}) {
  const s = styles[milestone];
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${s.pill}`} data-id="element-143" data-mp="f14qg20g3b5b">
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden="true" data-id="element-144" data-mp="227efe6fsu8z7" />
      {milestone}
    </span>;
}